module.exports = __webpack_public_path__ + "static/media/468x60_0006_ro.dbf12624.png";